import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IReminderRepository } from '../../repositories/interfaces/iReminderRepository';
import { IReminderListParams } from '../../../entity/interface/iReminder';

export interface IListReminderUseCase {
    execute(apikey: string, searchParams: IReminderListParams, token: string, identityToken: string): Promise<any>;
}
export class ListReminderUseCase implements IListReminderUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get setReminder(): IReminderRepository {
        return container.resolve<IReminderRepository>(DI.REPOSITORIES.IReminderRepository);
    }
    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apikey: string,
        searchParams: IReminderListParams,
        token: string,
        identityToken: string
    ): Promise<any> {
        return await this.setReminder.listReminder(apikey, searchParams, token, identityToken);
    }
}
